<template>
    <BreadCrumb PageTitle="Ajout d'une Vente" />
    <AddVente />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddVente from "../../components/Vente/AddVente.vue";

    export default defineComponent({
        name: "AddVentePage",
        components: {
            BreadCrumb,
            AddVente,
        },
    });
</script>